import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ScrollBottom extends Vue {
  public scrollBottom(element: HTMLElement) {
    if (element?.scrollHeight) {
      Vue.nextTick(() => {
        element.scrollTop = element.scrollHeight;
      });
    }
  }
}
